import {
  MotifErrorMessage,
  MotifFormField,
  MotifProgressLoader,
  MotifTable,
} from "@ey-xd/motif-react";
import useColumnDefinitions from "@/features/caselist/components/Constants/colHeaderConst";
import useCustomCellRenderers from "@/features/caselist/components/Constants/customCellConst";
// import { tableDetails } from "@/features/caselist/components/Constants/tableDetailsConst";
import { useTranslation } from "react-i18next";
import { useSearchCaseListDataQuery } from "@/services/cases/casesReducer";
import { useEffect, useMemo, useState } from "react";
import CustomPagination from "@/components/Pagination/CustomPagination";
import SearchInput from "@/components/SearchInput/SearchInput";
import { useDispatch, useSelector } from "react-redux";
import { useGetTimeZoneListQuery } from "@/pages/CaseDetail/Configuration/CaseTimeZones/caseTimeZoneReducer";
import { setTimeZone } from "@/pages/CaseDetail/Configuration/CaseTimeZones/caseTimeZoneSlice";
import {
  customPaginationPageSizeSelector,
  customTableLoadingData,
  tableRowHeight,
} from "@/components/Table/CustomPaginationConstants";
import { setComponentState1 } from "@/features/retain_state/retainStateSlice";
export default function CaseListTable() {
  const dispatchEvent = useDispatch();
  const { data } = useGetTimeZoneListQuery({});
  const retainState = useSelector((e: any) => e.retainState.allCasesTabState);
  const { t } = useTranslation();
  let tableLoadingData = customTableLoadingData;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  const getPaginationObj: any = useMemo(() => {
    let value: any = {
      currentPage: retainState?.PageNumber || 1,
      pageSize: retainState?.PageSize,
      searchText: retainState?.SearchText || "",
    };
    if (retainState?.SortOrder && retainState?.SortColumn) {
      value.SortOrder = retainState?.SortOrder;
      value.SortColumn = retainState?.SortColumn;
    }
    return value;
  }, [retainState]);
  const paginationObj = getPaginationObj;
  const cellRenderers = useCustomCellRenderers();

  const columnDefs = useColumnDefinitions();

  const [searchedData, setSearchData] = useState([]);
  let caseListPaginationData: any = {
    PageNumber: paginationObj.currentPage,
    PageSize: paginationObj.pageSize,
    SearchText: paginationObj.searchText,
  };
  if (paginationObj?.SortOrder && paginationObj.SortColumn) {
    caseListPaginationData.SortOrder = paginationObj.SortOrder;
    caseListPaginationData.SortColumn = paginationObj.SortColumn;
  }
  const {
    data: searchDataObj,
    error,
    isLoading: quickSearchLoader,
    isFetching,
    status: searchDataStatus,
  } = useSearchCaseListDataQuery({ ...caseListPaginationData });
  const searchData = searchDataObj?.results;
  const hasMoreRecords = searchDataObj?.hasMoreRecords;

  function handleSearch() {
    setSearchData(searchData);
    setComponentState1({
      entityName: "allCasesTabState",
      entityState: {
        SearchText: retainState.SearchText,
        PageNumber: 1,
        SortOrder: "asc",
        SortColumn: "CaseName",
        sortedColumnTypes: { ...resetSortStatus("caseNameType") },
      },
    });
  }
  useEffect(() => {
    if (data && data.length > 1) dispatchEvent(setTimeZone(data));
  }, [data, dispatchEvent]);
  function handlePaginationData(data: any, columnTypesData: any) {
    dispatchEvent(
      setComponentState1({
        entityName: "allCasesTabState",
        entityState: {
          SortOrder: data.SortOrder ,
          SortColumn: data.SortColumn,
          sortedColumnTypes: columnTypesData,
        },
      })
    );
  }
  function handleMotifSorting(e: any, paginationObj: any) {
    if (e?.source !== "gridOptionsChanged") {
    let sortedColumnsLength: any = e?.columns ? e.columns.length : "";
    if (sortedColumnsLength !== "") {
      let coumnName = e?.columns?.[sortedColumnsLength - 1]?.colId;
      let sortName = e?.columns?.[sortedColumnsLength - 1]?.sort;
      let typeName = e?.columns?.[sortedColumnsLength - 1]?.colDef?.type;
      let paginationJson: any = { ...paginationObj };
      let columnTypesCustom: any = {};
      if (typeName) {
        columnTypesCustom[typeName] = { sort: sortName };
      }
      paginationJson.SortOrder = sortName;
      paginationJson.SortColumn =
        coumnName?.charAt(0)?.toUpperCase() + coumnName?.slice(1);
      if (!sortName) {
        delete paginationJson.SortOrder;
        delete paginationJson.SortColumn;
      }
      if (e?.columns[0]?.colDef?.field) {
        if (handlePaginationData) {
          handlePaginationData(paginationJson, columnTypesCustom);
        }
      }
    }
  }
  }
  function resetSortStatus(defaultSort:string) {
    let json: any = { ...retainState.sortedColumnTypes };
    for (const key in json) {
      json[key] = { sort: null };
    }
    json[defaultSort] = { sort: "asc" };

    return json;
  }
  return (
    <>
      <div
        style={
          isFetching || searchData?.length === 0 ? { height: "150px" } : {}
        }
        className="ccwp_caselist_motif_table"
      >
        {error ? (
          <MotifErrorMessage
            style={{
              textAlign: "center",
              display: "block",
              alignItem: "center",
            }}
          >
            {t("global.globalNotifications.wentWrong")}
          </MotifErrorMessage>
        ) : quickSearchLoader ? (
          <MotifProgressLoader show variant="default" />
        ) : searchedData ? (
          <>
            <MotifTable
              // onGridReady={onGridReady}
              overlayNoRowsTemplate={
                isFetching
                  ? t(tableLoadingData)
                  : error
                  ? t("global.globalNotifications.wentWrong")
                  : t("global.globalNotifications.noRecords")
              }
              columnTypes={
                retainState.sortedColumnTypes
                  ? { ...retainState.sortedColumnTypes }
                  : {}
              }
              onSortChanged={(e: any) => {
                handleMotifSorting(e, paginationObj);
              }}
              defaultColDef={{
                cellStyle: {
                  whiteSpace: "normal",
                  lineHeight: "1.5",
                },
                minWidth:150
              }}
              suppressMultiSort={true}
              rowHeight={tableRowHeight}
              paginateChildRows={true}
            
              columnDefs={columnDefs}
              components={cellRenderers}
              description={t("pages.home.tableDescription")}
              rowData={searchData && !isFetching ? searchData : []}
              title={t("pages.home.tableTile")}
              titleComplement={
                <div>
                <MotifFormField>
                  <SearchInput
                    aria-label={t("Search")}
                    onChange={(e: any) => {
                      dispatchEvent(
                        setComponentState1({
                          entityName: "allCasesTabState",
                          entityState: {
                            SearchText: e.target.value,
                            PageNumber: 1,
                            SortOrder: "asc",
                            SortColumn: "CaseName",
                            sortedColumnTypes: { ...resetSortStatus("caseNameType") }
                          },
                        })
                      );
                    }}
                    value={retainState.SearchText}
                    onClear={() => {
                      dispatchEvent(
                        setComponentState1({
                          entityName: "allCasesTabState",
                          entityState: {
                            SearchText: "",
                            PageNumber: 1,
                            SortOrder: "asc",
                            SortColumn: "CaseName",
                            sortedColumnTypes: { ...resetSortStatus("caseNameType") }
                          },
                        })
                      );
                      setSearchData([]);
                    }}
                    onEnter={() => handleSearch()}
                    placeholder={t(
                      "global.globalPlaceholder.quickSearchPlaceHolder"
                    )}
                  />
                </MotifFormField>
                </div>
              }
            />
            <CustomPagination
              apiData={searchDataObj}
              apiStatus={searchDataStatus}
              currentpage={paginationObj.currentPage}
              pageSize={paginationObj.pageSize}
              disableNext={!hasMoreRecords}
              onChangePageSize={(page: number) => {
                dispatchEvent(
                  setComponentState1({
                    entityName: "allCasesTabState",
                    entityState: {
                      PageSize: page,
                      PageNumber: 1,
                    },
                  })
                );
              }}
              onChangeNextPage={() => {
                dispatchEvent(
                  setComponentState1({
                    entityName: "allCasesTabState",
                    entityState: {
                      PageNumber: paginationObj.currentPage + 1,
                    },
                  })
                );
              }}
              onChangePreviousPage={() => {
                dispatchEvent(
                  setComponentState1({
                    entityName: "allCasesTabState",
                    entityState: {
                      PageNumber: paginationObj.currentPage - 1,
                    },
                  })
                );
              }}
              pageSizeSelector={paginationPageSizeSelector}
            />
          </>
        ) : null}
      </div>
    </>
  );
}
